// removed by extract-text-webpack-plugin
module.exports = {"component":"_1xCnrvGuha8XfZZbYU4ITM","margins":"yQ9BSO3PnhxmgrSpdIkb-","form":"_29BbZ7EQ_6EQx1tSUWeVEz","header":"_3670alWMaL0nRqvg3QRkSZ","message":"_2cUS4UAvfOjSmVUdo9fw2Z","group":"_1AxOS4e51DHZXChPD51xue","groupStacked":"_2WXBjS_4-ad6y4klVJ5UBS","label":"_1XU8PozY7L3Vhu2uW7CONC","control":"eG1LYrik2ZzijPCn-gbfF","cta":"QWU6Lc4DHZ4y3a77jl4N5","btn":"_2gvmaE-Y5Em6dYtKdjRLh2","dialog":"FZyBItzGGVSADsRTWMXmw","dialogTitle":"_33tPIHiHF11fcb30F92wye","dialogCta":"_1zLhP4ACBtyLgewxfYLij1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/LoginForm/LoginForm.css
// module id = 1048
// module chunks = 0